
function move(array, fromIndex, toIndex) {
    const newArray = [...array];

    const item = newArray.splice(fromIndex, 1)[0];
    newArray.splice(toIndex, 0, item);
    return newArray;
}

export default {
    move,
};
